import {
  useTranslation,
  type TranslationKeys,
} from "@/hooks/useTranslation/useTranslation"
import { FieldsSectionHeader } from "../shared/FieldsSectionHeader"
import { FieldsSectionSkeleton } from "../shared/FieldsSectionSkeleton"

/**
 * Shared shell behind the Fields sections' `*FieldsHeader` components
 * (Articles, Products, Suppliers, Customers) — loading/empty gates plus the
 * name + subtitle + edit button row. `name`/`subtitle` are computed by the
 * caller from its own (possibly-still-undefined) entity via `?.`, so they're
 * typed optional here even though they're always defined by the time this
 * actually renders past the `!entity` gate below.
 */
export function EntityFieldsHeader<TOut>({
  entity,
  isLoading,
  editing,
  setEditing,
  labelKey,
  name,
  subtitle,
}: {
  entity: TOut | undefined
  isLoading: boolean
  editing: boolean
  setEditing: (editing: boolean) => void
  labelKey: TranslationKeys
  name: string | undefined
  subtitle: string | null | undefined
}) {
  const { translate } = useTranslation()

  if (isLoading) return <FieldsSectionSkeleton count={2} />
  if (!entity) return null

  return (
    <FieldsSectionHeader
      label={translate(labelKey)}
      name={name ?? ""}
      subtitle={subtitle}
      editing={editing}
      onEdit={() => setEditing(true)}
    />
  )
}
